export const MasterData = [
  {
    id: 1,
    linkText: "Acadamics",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "Acadamics",
    module: "Master",
    accessCode: "Acadamics",
  },
  {
    id: 1,
    linkText: "Bank",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "Bank",
    module: "Master",
    accessCode: "Bank",
  },
  // {
  //   id: 1,
  //   linkText: "Country",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "Country",
  //   module: "Master",
  //   accessCode: "Country",
  // },

  {
    id: 1,
    linkText: "Group",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "Group",
    module: "Master",
    accessCode: "Group",
  },
  {
    id: 1,
    linkText: "Visa Type",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "VisaType",
    module: "Master",
    accessCode: "VisaType",
  },
  // {
  //   id: 1,
  //   linkText: "CPF Contribution",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "CPFContribution",
  //   module: "Master",
  //   accessCode: "CPFContribution",
  // },
  // {
  //   id: 2,
  //   linkText: "CPF Contribution Rate",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "CPF.png",
  //   link: "CPFContributionRate",
  //   module: "Master",
  //   accessCode: "CPFContributionRate",
  // },
  // {
  //   id: 3,
  //   linkText: "CPF Percentage",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "Percentage.png",
  //   link: "CPFPercentage",
  //   module: "Master",
  //   accessCode: "CPFPercentage",
  // },
  // {
  //   id: 4,
  //   linkText: "CPF Percentage FLI",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "fli.png",
  //   link: "CPFPercentageFLI",
  //   module: "Master",
  //   accessCode: "CPFPercentageFLI",
  // },
  // {
  //   id: 5,
  //   linkText: "CPF Types",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "CPF.png",
  //   link: "CPFType",
  //   module: "Master",
  //   accessCode: "CPFTypes",
  // },
  {
    id: 5,
    linkText: "Contract Type",
    iconPath: "assets/img/master-icons/",
    icon: "CPF.png",
    link: "ContractType",
    module: "Master",
    accessCode: "ContarctType",
  },
  // {
  //   id: 5,
  //   linkText: "Employee Type",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "CPF.png",
  //   link: "EmployeeType",
  //   module: "Master",
  //   accessCode: "",
  // },
  {
    id: 5,
    linkText: "Employment Type",
    iconPath: "assets/img/master-icons/",
    icon: "CPF.png",
    link: "EmploymentType",
    module: "Master",
    accessCode: "EmploymentType",
  },
  {
    id: 1,
    linkText: "Employee Work Type",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "EmployeeWorkType",
    module: "Master",
    accessCode: "EmployeeWorkType",
  },
  {
    id: 6,
    linkText: "Identification",
    iconPath: "assets/img/master-icons/",
    icon: "locations.png",
    link: "Identification",
    module: "Master",
    accessCode: "Identification",
  },
  {
    id: 7,
    linkText: "Location",
    iconPath: "assets/img/master-icons/",
    icon: "locations.png",
    link: "Location",
    module: "Master",
    accessCode: "Location",
  },
  // {
  //   id: 7,
  //   linkText: "Nationality",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "locations.png",
  //   link: "Nationality",
  //   module: "Master",
  //   accessCode: "Nationality",
  // },

  {
    id: 8,
    linkText: "Pass Type",
    iconPath: "assets/img/master-icons/",
    icon: "Pass-Type.png",
    link: "PassType",
    module: "Master",
    accessCode: "PassType",
  },
  {
    id: 9,
    linkText: "Pay Mode",
    iconPath: "assets/img/master-icons/",
    icon: "Paymode.png",
    link: "Paymode",
    module: "Master",
    accessCode: "PayMode",
  },
  // {
  //   id: 9,
  //   linkText: "Race",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "Paymode.png",
  //   link: "Race",
  //   module: "Master",
  //   accessCode: "Race",
  // },
  {
    id: 9,
    linkText: "Relationship",
    iconPath: "assets/img/master-icons/",
    icon: "Paymode.png",
    link: "Relationship",
    module: "Master",
    accessCode: "Relationship",
  },
  // {
  //   id: 1,
  //   linkText: "Levy Type",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "LevyType",
  //   module: "Master",
  //   accessCode: "LevyType",
  // },
  // {
  //   id: 1,
  //   linkText: "Levy Amount Type",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "LevyAmountType",
  //   module: "Master",
  //   accessCode: "LevyAmountType",
  // },
  {
    id: 1,
    linkText: "Trade",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "Trade",
    module: "Master",
    accessCode: "Trade",
  },
  {
    id: 1,
    linkText: "Mom Trade",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "MomTrade",
    module: "Master",
    accessCode: "MOMTrade",
  },
  {
    id: 1,
    linkText: "Dormitory",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "Dormitory",
    module: "Master",
    accessCode: "Dormitory",
  },
  {
    id: 1,
    linkText: "Employee Status",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "EmployeeStatus",
    module: "Master",
    accessCode: "EmployeeStatus",
  },

  {
    id: 1,
    linkText: "Foreigner Levy",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "Foreignerlevy",
    module: "Master",
    accessCode: "ForeignerLevy",
  },
  {
    id: 1,
    linkText: "Insurance Type",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "Insurancetype",
    module: "Master",
    accessCode: "InsuranceType",
  },
  {
    id: 1,
    linkText: "Vehicle Category",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Master/Vehicle/VehicleCategory",
    module: "Master",
    accessCode: "VehicleCategory",
  },
  // {
  //   id: 1,
  //   linkText: "Vehicle Accident",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "VehicleAccident",
  //   module: "Master", accessCode: "",
  // },
  // {
  //   id: 1,
  //   linkText: "Diesel Usage",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "DieselUsage",
  //   module: "Master", accessCode: "",
  // },
  {
    id: 1,
    linkText: "Vehicle Type",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Master/Vehicle/VehicleType",
    module: "Master",
    accessCode: "VehicleType",
  },
  // {
  //   id: 1,
  //   linkText: "Vehicle Maintenance",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "Vehiclemaintenance",
  //   module: "Master", accessCode: "",
  // },
  // {
  //   id: 1,
  //   linkText: "Vehicle Information",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "Vehicleinformation",
  //   module: "Master", accessCode: "",
  // },
  // {
  //   id: 1,
  //   linkText: "Vehicle Expenses",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "Vehicleexpenses",
  //   module: "Master", accessCode: "",
  // },
  // {
  //   id: 1,
  //   linkText: "Vehicle Indemnity",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "Vehicleindemnity",
  //   module: "Master", accessCode: "",
  // },
  //  {
  //    id: 9,
  //    linkText: "Shift Type",
  //    iconPath: "assets/img/master-icons/",
  //    icon: "Paymode.png",
  //    link: "ShiftType",
  //    module: "Master", accessCode: "",
  //  },
  // {
  //   id: 1,
  //   linkText: "Working Day Type",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "WorkingDayType",
  //   module: "Master",
  //   accessCode: "WorkingDayType",
  // },
];

export const reportList = [
  {
    id: 1,
    linkText: "Addition / Deduction Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Addition-Deduction-Report",
    module: "Report",
    accessCode: "Addition / Deduction Report",
  },
  {
    id: 1,
    linkText: "Advance Payment Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Advance-Payment-Report",
    module: "Report",
    accessCode: "Advance Payment Report",
  },
  {
    id: 1,
    linkText: "Advance Repayment Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Advance-Repayment-Report",
    module: "Report",
    accessCode: "Advance Repayment Report",
  },

  {
    id: 1,
    linkText: "Attendance Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Attendance-Report",
    module: "Report",
    accessCode: "Employee Attendance Report",
  },
  // {
  //   id: 1,
  //   linkText: "Leave Report",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "/Report/Leave-Report",
  //   module: "Report",
  //   accessCode: "Leave Report",
  // },
  {
    id: 1,
    linkText: "Emp Leave History",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Emp-Leave-History",
    module: "Report",
    accessCode: "Employee Leave History",
  },
  {
    id: 1,
    linkText: "Monthly Payroll Summary",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Monthly-Payroll-Summary",
    module: "Report",
    accessCode: "Monthly Payroll Summary",
  },
  {
    id: 1,
    linkText: "Payslip Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Payslip-Report",
    module: "Report",
    accessCode: "Employee Payslip Report",
  },
  // {
  //   id: 1,
  //   linkText: "Project Report",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "/Report/Project-Report",
  //   module: "Report", accessCode: "",
  // },

  {
    id: 1,
    linkText: "Forecast Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Forecast-Report",
    module: "Report",
    accessCode: "Payroll Forecast Report",
  },
    {
    id: 1,
    linkText: "Levy Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Levy-Report",
    module: "Report",
    accessCode: "Payroll Forecast Report",
  },
  {
    id: 1,
    linkText: "Contract Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Contract-Report",
    module: "Report",
    accessCode: "Employment Contract Overview",
  },
  {
    id: 1,
    linkText: "Expiry Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Expiry-Report",
    module: "Report",
    accessCode: "Document Expiry Report",
  },
  {
    id: 1,
    linkText: "Man Hour Project Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Man-Hour-Project-Report",
    module: "Report",
    accessCode: "Project Man-Hour Analysis",
  },
  // {
  //   id: 1,
  //   linkText: "Daily Work Order Report",
  //   iconPath: "assets/img/master-icons/",
  //   icon: "cpf.png",
  //   link: "/Report/Daily-Work-Order-Report",
  //   module: "Report",
  //   accessCode: "Daily Work Order Report",
  // },
  {
    id: 1,
    linkText: "Employee Details Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Employee-Details-Report",
    module: "Report",
    accessCode: "Employee Details Report",
  },
  {
    id: 1,
    linkText: "Employee Count Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Employee-Count-Report",
    module: "Report",
    accessCode: "Employee Count Report",
  },
    {
    id: 1,
    linkText: "Project Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Project-Report",
    module: "Report",
    accessCode: "Project Report",
  },
   {
    id: 1,
    linkText: "Project Costing Report",
    iconPath: "assets/img/master-icons/",
    icon: "cpf.png",
    link: "/Report/Project-Costing-Report",
    module: "Report",
    accessCode: "Project Costing Report",
  },
];
